export const UPDATE_MFA_API_USER = 'update_mfa_api_user';
export const UPDATE_ADFS_API_TOKEN = 'update_adfs_api_token';
export const UPDATE_ALLOW_EXTERNAL_RISK_API = 'update_allow_external_risk_api';
